<template>
  <a :href="cellProps.link">
    {{ cellProps.number }} van {{ cellProps.customer_name }}
  </a>
</template>

<script>
import { DateFormatEnum } from "~/enums";

export default {
  props: {
    cellProps: {
      type: Object,
    },
  },
  data() {
    return {
      DateFormatEnum,
    };
  },
};
</script>

<style scoped></style>
